import styled from '@emotion/styled';
import { ifNotProp } from 'styled-tools';
import { LinkButton as GenericLinkButton } from '../Button';

export const Container = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: theme.space[8],
}));

export const PagingLink = styled(GenericLinkButton, {
    shouldForwardProp: (prop) => prop !== 'hasNextPage' && prop !== 'isLoading',
})<{ hasNextPage?: boolean; isLoading?: boolean }>(
    ({ theme }) => ({
        marginBottom: theme.space[4],
    }),

    ifNotProp('hasNextPage', {
        display: 'none',
    })
);
